<ch-loader [loading]="isInitialLoading"></ch-loader>
<div [ngStyle]="{ display: isInitialLoading ? 'none' : 'block' }">
  <ch-breadcrumb [parts]="breadcrumb" (goTo)="breadcrumbGoTo($event)"></ch-breadcrumb>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 col-md-12">
        <form (ngSubmit)="save(form)" #form="ngForm">
          <div class="card mb-4">
            <div class="card-header">Form</div>
            <div class="card-body">
              <div class="form-group">
                <label for="referral-programs-edit-name">Name</label>
                <input type="text" [(ngModel)]="referralProgramData.name" name="name" #name="ngModel"
                  class="form-control" id="referral-programs-edit-name" required [readonly]="loading" />
                <div class="mx-2 mt-2" style="display: flex; flex-direction: column">
                  <small class="text-success">
                    <strong>NB:</strong> This name will appear what appears for the Member on the 'Refer A Friend'
                  </small>
                  <small class="text-danger" *ngIf="(name.touched || name.dirty) && !name.valid">
                    Name is invalid.
                  </small>
                </div>
              </div>
              <div style="margin-top: 40px">
                <span class="btn-left" *ngIf="referralProgramId">
                  <button id="referralProgramsEditCancel" type="button" class="btn btn-danger" (click)="delete()"
                    [disabled]="loading">
                    Delete
                  </button>
                  <button *ngIf="!referralProgramData.archivedAt; else isArchived" id="referralProgramsEditCancel"
                    type="button" class="btn btn-warning" (click)="archive()" [disabled]="loading">
                    Archive
                  </button>
                  <ng-template #isArchived>
                    <span class="ml-4" style="font-weight: bold; font-style: italic">This program is archived</span>
                  </ng-template>
                </span>
                <span class="btn-right">
                  <button id="referralProgramsEditCancel" type="button" class="btn btn-secondary" (click)="cancel()"
                    [disabled]="loading">
                    Cancel
                  </button>
                  <button id="referralProgramsEditSave" type="submit" class="btn btn-primary" [disabled]="loading">
                    Save
                  </button>
                </span>
              </div>
            </div>
          </div>
        </form>
        <ch-rewards-list *ngIf="referralProgramId"></ch-rewards-list>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/referrals/programs/programs-edit.component.html